import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Navbar() {
  const [username, setUsername] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/user') 
      .then((response) => response.json())
      .then((data) => setUsername(data.username))
      .catch((error) => {
        console.error('Error fetching username:', error);
        setUsername(null);
      });
  }, []);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const closeDropdown = () => {
    setShowDropdown(false);
  };

  const handleLogout = () => {
    closeDropdown();
    navigate('/login', { replace: true });
  };

  return (
    <div className="admin-navbar-wrapper">
      <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <div className="ms-auto position-relative">
              <button
                className="btn btn-light dropdown-toggle"
                type="button"
                onClick={toggleDropdown}
              >
                {username ? `Welcome, ${username}` : 'Not logged in'}
              </button>

              {showDropdown && (
                <ul
                  className="dropdown-menu dropdown-menu-end show"
                  style={{ position: 'absolute', top: '100%', right: 0 }}
                >
                  <li>
                    <button className="dropdown-item" onClick={handleLogout}>
                      Logout
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
